import { render, staticRenderFns } from "./threedrotate.vue?vue&type=template&id=81cc8302&scoped=true&"
import script from "./threedrotate.vue?vue&type=script&lang=js&"
export * from "./threedrotate.vue?vue&type=script&lang=js&"
import style0 from "./threedrotate.vue?vue&type=style&index=0&id=81cc8302&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cc8302",
  null
  
)

export default component.exports